import { Tab } from '../../model/tabs/tab';

export class TabBuilder {
  private tab: Tab;

  constructor(id: string, label: string, contentId = '') {
    this.tab = new Tab(id, label, contentId || id);
  }

  public setContentId(contentId: string): TabBuilder {
    this.tab.contentId = contentId;
    return this;
  }

  public setIcon(icon: string): TabBuilder {
    this.tab.icon = icon;
    return this;
  }

  public open(): TabBuilder {
    this.tab.isOpen = true;
    return this;
  }

  public close(): TabBuilder {
    this.tab.isOpen = false;
    return this;
  }

  public setIsOpen(isOpen: boolean): TabBuilder {
    this.tab.isOpen = isOpen;
    return this;
  }

  public setConfirmBeforeClose(confirmBeforeClose: boolean): TabBuilder {
    this.tab.confirmBeforeClose = confirmBeforeClose;
    return this;
  }

  public setCanClose(canClose: boolean): TabBuilder {
    this.tab.canClose = canClose;
    return this;
  }

  public setColor(color: string): TabBuilder {
    this.tab.color = color;
    return this;
  }

  public enable(): TabBuilder {
    this.tab.enable = true;
    return this;
  }

  public disable(): TabBuilder {
    this.tab.enable = false;
    return this;
  }

  public setEnable(enable: boolean): TabBuilder {
    this.tab.enable = enable;
    return this;
  }

  public setRoute(route: string) {
    this.tab.route = route;
    return this;
  }

  public build(): Tab {
    return this.tab;
  }
}
